module.exports = require('./dist/react-beautiful-dnd')
